// extracted by mini-css-extract-plugin
export default {"article":"AppCarouselTeamItem_article_VWgiJ","head":"AppCarouselTeamItem_head_n3zsH"};